<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>


export default {
  name: 'app'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

#app {
  display: flex;
  flex-direction: column;
}


.container {
  display: flex;
  flex-direction: column;
  width: 100vw;
}
</style>
